import jQuery from 'jquery';
let $ = jQuery;

window.HsnDrdPageCache = {
    Referrer: "",
    
    setDCookie: function() {
        var deviceInfo = this.getDeviceInfo();
        this.setCookie("D", deviceInfo.DeviceKey, this.getLowerDomain(), 84, "/");
    },
    resetDCookie: function () {
        var dValue = this.getCookie("D");
        if (dValue != "") {
            this.setCookie("D", "", this.getLowerDomain(), -10, "/");
        }
    },
    resetRCookie: function() {
        var rValue = this.getCookie(".R");
        if (rValue != "") {
            this.Referrer = unescape(rValue);
            this.setCookie(".R", "", this.getLowerDomain(), -10, "/");
        }
    },
    getLowerDomain: function () {
        var ret = document.domain;
        var work = ret.split(".");
        if (work.length >= 2) {
            var work1 = new Array(work[work.length - 2], work[work.length - 1]);
            ret = "." + work1.join(".");
        }
        return ret;
    },

    setCookie: function (name, value, myDomain, expireDays, path) {
        var expire = new Date();
        if (expireDays != null)
            expire.setDate(expire.getDate() + expireDays);
        document.cookie = name + "=" + value
            + ((myDomain == null) ? "" : ("; domain=" + myDomain))
            + ((expireDays == null) ? "" : ("; expires=" + expire.toGMTString()))
            + ((path == null) ? "" : ("; path=" + path));
    },
    
    getCookie: function(name) {
        var search = name + "=";
        if (document.cookie.length > 0) {
            var offset = document.cookie.indexOf(search);
            if (offset != -1) { 
                offset += search.length;
                var end = document.cookie.indexOf(";", offset);
                if (end == -1)
                    end = document.cookie.length;
                return document.cookie.substring(offset, end);
            }
        }
        return "";
    },

    removeCookie: function(name) {
        this.setCookie(name, "", "", -1);
    },

    getQueryString: function (name) {
        var search = window.location.search.substring(1);
        var qs = search.split("&");
        for (var idx = 0; idx < qs.length; idx++) {
            var pair = qs[idx].split("=");
            if (pair[0].toLowerCase() == name.toLowerCase()) {
                if (pair.length > 1)
                    return pair[1];
                else
                    return "";
            }

        }
        return "";
    },
    updateQueryStringParameter: function (uri, key, value) {
        var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
        var separator = uri.indexOf('?') !== -1 ? "&" : "?";
        if (uri.match(re)) {
            return uri.replace(re, '$1' + key + "=" + value + '$2');
        }
        else {
            return uri + separator + key + "=" + value;
        }
    },
    getDeviceInfo: function () {
        var deviceJson = $('.device-information').html();
        return deviceJson ? JSON.parse(deviceJson) : null;
    },
};


// WEBPACK FOOTER //
// ./assets/js/HSN/CookieCheck.js